<template>
  <div id="centerRight2">
    <div class="chartInstanceBox">
      <div class="chartInstanceBoxTitle">
        就业薪资排行统计
      </div>
      <div id="chartInstance" ref="chartInstance"> </div>
    </div>
  </div>
</template>

<script>
import { getSalaryRankingApi } from '@/utils/api'

export default {
  data() {
    return {
      salaryRanking:[]
    }
  },
  mounted() {
    this.getSalaryRanking()
  },

  methods: {
    async getSalaryRanking(data) {
      await getSalaryRankingApi({
        ...data,
        size:5
      }).then(res => {
        this.salaryRanking = res.data.data
        this.chartInstanceInit()
      })
    },

    chartInstanceInit() {
      const chartInstance = this.$echarts.init(this.$refs.chartInstance)
      const initOption = {
        color: '#7dedfc',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            axisPointer: {
              type: 'shadow'
            },
            crossStyle: {
              color: '#999'
            }
          }
        },

        grid: {
          x: 0,
          y: 20,
          x2: 0,
          y2: 20,
          containLabel: true
        },
        yAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ffffff',
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#3b3b3c',
                width: 1,
                type: 'solid'
              }
            },
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              color: '#fff'
            },
            data: this.salaryRanking.nameList
          }
        ],
        xAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#fff'
            },
            offset: -5,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#8A8C91'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#232F3A',
                width: 2,
                type: 'dotted'
              }
            },
            nameTextStyle: {
              rich: {
                legend: {
                  width: 12,
                  height: 4,
                  backgroundColor: 'red'
                },
                value: {
                  color: '#FF8C00'
                }
              }
            }
          }
        ],
        series: [
          {
            type: 'bar',
            name: '数量',
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                offset: 0,
                color: '#28EFEF'
              },
              {
                offset: 1,
                color: '#5945EC'
              }]),
            },
            barWidth: 21,
            data: this.salaryRanking.valueList,
          },
        ]
      }
      // console.log(initOption);
      chartInstance.setOption(initOption)
    },

    //切换行业类型
    clickAction(e) {
      this.industryType = e
    },
  }
}
</script>

<style lang="scss" scoped>
#chartInstance {
  width: 480px;
  height: 268px;
  /* margin-left: -60px; */
}
#centerRight2{
  /* margin-top: -35px; */
}
.chartInstanceBox {
  box-sizing: border-box;
   /* padding-top: 31px; */
  position: relative;
  width: 480px;
   /* height: 250px; */

  .chartInstanceBoxTitle {
    font-weight: bold;
    font-size: 28px;
    color: #0EE1F4;
    background: linear-gradient(179deg, #0EE1F4 0%, #0096FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: right;
  }
}
</style>
